import { Form } from 'antd';
import Checkbox, { CheckboxProps } from 'antd/lib/checkbox';
import { Rule } from 'antd/lib/form';
// import { RuleObject } from 'antd/lib/form';
import Paragraph from 'components/atoms/Paragraph';
import TranslateText from 'components/hoc/TranslateText';
import React from 'react';

const { Item } = Form;

interface ICheckboxComponent extends CheckboxProps {
    name: string;
    autoFocus?: boolean;
    checked?: boolean;
    defaultChecked?: boolean;
    disabled?: boolean;
    indeterminate?: boolean;
    onChange?: (e: unknown) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    checkboxText: any; // TODO: Zbavit se any
    extramessage?: string;
    rules?: Rule[];
}

const CheckboxComponent: React.FC<ICheckboxComponent> = props => {
    const {
        name,
        autoFocus,
        checked,
        defaultChecked,
        indeterminate,
        onChange,
        checkboxText,
        extramessage,
        rules
    } = props;

    return (
        <>
            <Item
                {...{
                    wrapperCol: {
                        span: 24
                    },
                    labelCol: {
                        span: 0
                    }
                }}
                name={name}
                extra={extramessage ? <Paragraph text={extramessage} className="extramessage-text" /> : null}
                valuePropName="checked"
                rules={
                    rules
                        ? rules
                        : [
                              {
                                  required: true,
                                  transform: value => value || undefined,
                                  type: 'boolean',
                                  message: (
                                      <div className="checkbox-component-rulesmg">
                                          <TranslateText>POTVRDIT_SOUHLAS</TranslateText>
                                      </div>
                                  )
                              }
                          ]
                }
            >
                <Checkbox
                    autoFocus={autoFocus}
                    checked={checked}
                    defaultChecked={defaultChecked}
                    indeterminate={indeterminate}
                    onChange={onChange}
                >
                    <>
                        <Paragraph
                            text={checkboxText}
                            style={{
                                margin: '0'
                            }}
                        />
                    </>
                </Checkbox>
            </Item>
            {extramessage && <Paragraph text={extramessage} className="extramessage-text" />}
        </>
    );
};

export default CheckboxComponent;
